import React from "react";

export default function NotFound() {
  return (
    <div className="flex h-screen">
      <h1 className="m-auto text-5xl">Page Not Found</h1>
    </div>
  );
}
